/* Kaffeefinder -- Oberflaeche
 * =================================================================
 * Die Regeln stehen in lb-kaffeefinder-logik.js und werden dort geprueft.
 * Hier nur Darstellung, Ereignisse, Adresszeile und Live-Preise.
 */
(function () {
  'use strict';

  var L = window.LBKaffeefinderLogik;

  /* Gruen (4 Kaffees) und Gaerig (3) sind keine Kacheln -- ein Klick darauf
     fuehrte in eine fast leere Liste. Als Datenwert bleiben sie erhalten.
     Die Untertitel sind echte Begriffe aus dem Rad, keine erfundenen
     Umschreibungen. Sie nehmen "Suess" die Doppeldeutigkeit: es geht nicht
     um Zucker. */
  var GRUPPEN_KACHELN = [
    { name: 'Nussig',   unter: 'Haselnuss, Mandel, Milchschokolade, Zartbitter' },
    { name: 'Süß',      unter: 'Karamell, Honig, Vanille, Sahne' },
    { name: 'Fruchtig', unter: 'Beeren, Zitrus, Pfirsich, Mango' },
    { name: 'Würzig',   unter: 'Zimt, Nelke, Lakritz, Anis' },
    { name: 'Blumig',   unter: 'Jasmin, Rose, Hibiskus, Schwarztee' },
    { name: 'Röstig',   unter: 'Malz, Toast, Tabak, Rauch' }
  ];

  var LISTENFELDER = ['geraete', 'gruppen', 'zubereitung', 'noten', 'roestgrad',
                      'aufbereitung', 'mischung', 'laender', 'roesterei'];

  function text(wert) {
    return String(wert === null || wert === undefined ? '' : wert)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function umschalten(liste, wert) {
    var i = liste.indexOf(wert);
    if (i === -1) liste.push(wert); else liste.splice(i, 1);
    return liste;
  }

  /* Antworten stehen in der Adresszeile, damit ein Ergebnis teilbar und mit
     dem Zurueck-Button bedienbar ist. Das Team im Showroom kann jemandem den
     Link hinterherschicken. */
  function zustandAusAdresse() {
    var z = L.leererZustand();
    var p = new URLSearchParams(window.location.search);
    LISTENFELDER.forEach(function (feld) {
      var roh = p.get(feld);
      if (roh) z[feld] = roh.split(',').filter(Boolean);
    });
    if (p.get('staerke')) z.staerkewunsch = p.get('staerke');
    z.zucker = p.get('zucker') === '1';
    z.koffeinfrei = p.get('koffeinfrei') === '1';
    if (p.get('preisMax')) z.preisMax = parseFloat(p.get('preisMax'));
    return z;
  }

  /* Die Adresszeile gehoert nicht nur uns: Newsletter-Links haengen
     utm_source & Co. an, die Staging-Vorschau haengt view= und
     preview_theme_id= an, kuenftig kommt vielleicht ein Rabatt-Parameter
     dazu. Deshalb von der aktuellen Query ausgehen, nur die eigenen
     Schluessel entfernen und neu setzen -- alles Fremde bleibt stehen.
     Nicht "vereinfachen" zu einer leeren URLSearchParams: das reisst
     jeden fremden Parameter beim ersten Klick heraus. */
  function adresseAusZustand(zustand) {
    var p = new URLSearchParams(window.location.search);
    LISTENFELDER.forEach(function (feld) { p.delete(feld); });
    p.delete('staerke');
    p.delete('zucker');
    p.delete('koffeinfrei');
    p.delete('preisMax');

    LISTENFELDER.forEach(function (feld) {
      if ((zustand[feld] || []).length) p.set(feld, zustand[feld].join(','));
    });
    if (zustand.staerkewunsch) p.set('staerke', zustand.staerkewunsch);
    if (zustand.zucker) p.set('zucker', '1');
    if (zustand.koffeinfrei) p.set('koffeinfrei', '1');
    if (zustand.preisMax !== null && zustand.preisMax !== undefined) {
      p.set('preisMax', String(zustand.preisMax));
    }
    var suche = p.toString();
    window.history.replaceState({}, '',
      window.location.pathname + (suche ? '?' + suche : ''));
  }

  /* Fuenf Geraetesilhouetten. Der vorhandene Satz lb-icon-geraet zeichnet
     Merkmale von Maschinen (Display, Milch, Temperatur), nicht die Geraetetypen
     selbst -- diese hier sind neu, folgen aber derselben Hausform: 24x24,
     strichbasiert, currentColor. Nur Frage 1 bekommt Symbole: Siebtraeger und
     Mokkakanne erkennt man an der Silhouette schneller als am Wort. Bei
     "Espresso pur" gegen "Americano" waeren es zwei fast gleiche Tassen --
     Dekoration ohne Erkennungswert. */
  var GERAET_SYMBOL = {
    /* Siebtraeger von der Seite: Sieb, Griff nach rechts, zwei Auslaeufe.
       Der erste Entwurf war ein Kreis mit Stiel und las sich als Lupe. */
    siebtraeger: '<path d="M2.5 7.5h11v2.5a5.5 5.5 0 0 1-11 0V7.5Z"/>' +
      '<path d="M13.5 9h8"/><path d="M6 15.5v3M10 15.5v3"/>',
    /* Korpus oben, offene Nische darunter, Tasse darin, Standflaeche.
       Das ist die Silhouette, an der man einen Vollautomaten erkennt -- die
       beiden Vorgaenger (breites Rechteck mit Linie, dann Kasten auf Kasten)
       lasen sich als Monitor beziehungsweise als Stapel. */
    vollautomat: '<rect x="4" y="2.5" width="16" height="11.5" rx="1.6"/>' +
      '<path d="M9.5 6h5"/>' +
      '<path d="M12 14v1.4"/>' +
      '<path d="M6 14v7M18 14v7"/><path d="M4 21h16"/>' +
      '<path d="M9 16.4h6l-.8 4h-4.4l-.8-4Z"/>',
    /* Handfilter: Kegel oben breit, unten schmal, darunter die Kanne.
       Der erste Entwurf war oben und unten breit und las sich als Sanduhr. */
    filter: '<path d="M3.5 3.5h17l-6.5 8h-4l-6.5-8Z"/><path d="M12 11.5v2"/>' +
      '<path d="M6.5 14h11l-1 6.5a1 1 0 0 1-1 .9H8.5a1 1 0 0 1-1-.9L6.5 14Z"/>',
    frenchpress: '<rect x="6" y="7" width="12" height="14" rx="1.5"/>' +
      '<path d="M6 7h12"/><path d="M12 7V3"/><path d="M9 3h6"/><path d="M6.5 12h11"/>',
    mokka: '<path d="M7 3.5h10l-1.5 7h-7L7 3.5Z"/>' +
      '<path d="M8.5 10.5h7l1.5 10h-10l1.5-10Z"/><path d="M17 6h3.5v4H17"/>'
  };

  function symbol(id) {
    var d = GERAET_SYMBOL[id];
    if (!d) return '';
    return '<svg class="lbkf__symbol" viewBox="0 0 24 24" width="40" height="40"' +
      ' aria-hidden="true" focusable="false" fill="none" stroke="currentColor"' +
      ' stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
      d + '</svg>';
  }

  function kachel(id, name, unter, gedrueckt, farbe, symbolId) {
    /* Ohne Untertitel wird zentriert -- ein einzelnes "Espresso pur" links in
       einer breiten Kachel sieht verloren aus. Mit Untertitel bleibt es links:
       zwei Zeilen zentriert flattern an beiden Raendern und lesen sich
       schlechter. */
    var klassen = 'lbkf__kachel' + (unter ? '' : ' lbkf__kachel--kurz');
    return '<li><button type="button" class="' + klassen + '" data-wert="' + text(id) + '"' +
      (farbe ? ' style="--lbkf-gruppe: ' + text(farbe) + '"' : '') +
      ' aria-pressed="' + (gedrueckt ? 'true' : 'false') + '">' +
      (farbe ? '<span class="lbkf__kachel-band" aria-hidden="true"></span>' : '') +
      (symbolId ? symbol(symbolId) : '') +
      '<span class="lbkf__kachel-name">' + text(name) + '</span>' +
      (unter ? '<span class="lbkf__kachel-unter">' + text(unter) + '</span>' : '') +
      '</button></li>';
  }

  function frageBlock(feld, titel, hinweis, kachelHtml) {
    return '<section class="lbkf__frage" data-feld="' + text(feld) + '">' +
      '<h2 class="lbkf__frage-titel">' + text(titel) + '</h2>' +
      '<p class="lbkf__frage-hinweis">' + text(hinweis) + '</p>' +
      '<ul class="lbkf__kacheln" role="list">' + kachelHtml + '</ul>' +
      '</section>';
  }

  function zeichneFragen(wurzel) {
    var z = wurzel.lbkfZustand;
    var daten = wurzel.lbkfDaten;
    var html = '';

    /* Frage 1 -- Ausschluss, keine Gewichtung. Was nicht in die Maschine
       passt, erscheint nicht. */
    html += frageBlock('geraete', 'Womit brühst du?',
      'Mehrfachauswahl. Wir zeigen dir nur, was bei dir funktioniert.',
      L.GERAETE.map(function (g) {
        return kachel(g.id, g.label, '', z.geraete.indexOf(g.id) !== -1, null, g.id);
      }).join(''));

    html += frageBlock('gruppen', 'Wohin soll’s geschmacklich gehen?',
      'Mehrfachauswahl.',
      GRUPPEN_KACHELN.map(function (g) {
        return kachel(g.name, g.name, g.unter, z.gruppen.indexOf(g.name) !== -1,
                      daten.gruppenfarben[g.name]);
      }).join(''));

    /* Frage 3 haengt an Frage 1: aus einer French Press kommt kein
       Cappuccino. Bei Mehrfachauswahl werden die Listen zusammengelegt. */
    var moeglich = [];
    z.geraete.forEach(function (id) {
      (L.ZUBEREITUNG_JE_GERAET[id] || []).forEach(function (zb) {
        if (moeglich.indexOf(zb) === -1) moeglich.push(zb);
      });
    });
    if (moeglich.length) {
      html += frageBlock('zubereitung', 'Wie trinkst du ihn?',
        'Mehrfachauswahl.',
        moeglich.map(function (id) {
          return kachel(id, L.ZUBEREITUNGEN[id].label, '',
                        z.zubereitung.indexOf(id) !== -1, null);
        }).join(''));
    } else {
      /* Frage 3 haengt an Frage 1 -- aber sie muss trotzdem von Anfang an
         dastehen: Die Ueberschrift verspricht vier Fragen, und wer nur drei
         sieht, zaehlt nach. Also Titel zeigen und den Grund nennen, statt
         die Frage aus dem Nichts auftauchen zu lassen. */
      html += '<section class="lbkf__frage lbkf__frage--wartet" data-feld="zubereitung">' +
        '<h2 class="lbkf__frage-titel">Wie trinkst du ihn?</h2>' +
        '<p class="lbkf__frage-hinweis">Sag uns zuerst, womit du brühst — ' +
        'dann zeigen wir dir nur, was in deine Tasse passt.</p></section>';
    }

    html += frageBlock('staerkewunsch', 'Wie kräftig darf er sein?',
      'Eine Auswahl.',
      Object.keys(L.STAERKEWUNSCH).map(function (id) {
        var w = L.STAERKEWUNSCH[id];
        return kachel(id, w.label, w.unter, z.staerkewunsch === id, null);
      }).join(''));

    /* Zwei Randbedingungen am Ende, nicht am Anfang. Entkoffeiniert stand
       zuerst ueber allem -- den Finder damit zu eroeffnen ist aber fuer die
       83 von 91 Kaffees, die es nicht sind, eine seltsame erste Begegnung.
       Am Filter aendert die Stelle nichts: koffeinfrei bleibt eine harte
       Bedingung in erfuelltHart, Zucker bleibt ein Bitterkeitssignal. */
    html += '<section class="lbkf__frage" data-feld="rahmen">' +
      '<p class="lbkf__frage-hinweis">Zwei Kleinigkeiten noch.</p>' +
      '<label class="lbkf__schalter">' +
      '<input type="checkbox" data-wert="zucker" data-lbkf-zucker' +
      (z.zucker ? ' checked' : '') + '>' +
      '<span>Ich süße meinen Kaffee.</span></label>' +
      '<label class="lbkf__schalter">' +
      '<input type="checkbox" data-wert="koffeinfrei" data-lbkf-koffeinfrei' +
      (z.koffeinfrei ? ' checked' : '') + '>' +
      '<span>Ich suche entkoffeinierten Kaffee.</span></label></section>';

    wurzel.querySelector('[data-lbkf-fragen]').innerHTML = html;
  }

  function verdrahteFragen(wurzel) {
    var behaelter = wurzel.querySelector('[data-lbkf-fragen]');

    behaelter.addEventListener('click', function (e) {
      var knopf = e.target.closest('.lbkf__kachel');
      if (!knopf) return;
      /* Nur die vier Fragen, nicht die Verfeinerung -- die haengt an einem
         eigenen Behaelter und schaerft dieselbe Suche, statt sie zu
         beginnen. */
      meldeSchritt('frage_beantwortet');
      var feld = knopf.closest('[data-feld]').dataset.feld;
      var z = wurzel.lbkfZustand;

      /* Wer die Fragen aendert, sucht etwas anderes -- dann ist die alte
         Kiste nicht mehr gemeint. Die Verfeinerung dagegen schaerft dieselbe
         Suche, dort bleibt sie stehen. */
      wurzel.lbkfAuswahl = null;
      if (feld === 'staerkewunsch') {
        /* Einfachauswahl, aber abwaehlbar -- sonst kommt niemand aus einem
           Fehlklick heraus. */
        z.staerkewunsch = z.staerkewunsch === knopf.dataset.wert ? null : knopf.dataset.wert;
      } else {
        umschalten(z[feld], knopf.dataset.wert);
        if (feld === 'geraete') {
          /* Wer sein Geraet wechselt, hat vielleicht Zubereitungen gewaehlt,
             die es dort nicht gibt. Die muessen weg, sonst rechnet der Finder
             mit Antworten, die niemand mehr sieht. */
          var erlaubt = [];
          z.geraete.forEach(function (id) {
            (L.ZUBEREITUNG_JE_GERAET[id] || []).forEach(function (zb) {
              if (erlaubt.indexOf(zb) === -1) erlaubt.push(zb);
            });
          });
          z.zubereitung = z.zubereitung.filter(function (zb) {
            return erlaubt.indexOf(zb) !== -1;
          });
        }
      }
      wurzel.lbkfNeuzeichnen();
    });

    behaelter.addEventListener('change', function (e) {
      if (e.target.matches('[data-lbkf-zucker]')) {
        wurzel.lbkfZustand.zucker = e.target.checked;
        wurzel.lbkfNeuzeichnen();
      }
      if (e.target.matches('[data-lbkf-koffeinfrei]')) {
        wurzel.lbkfZustand.koffeinfrei = e.target.checked;
        wurzel.lbkfNeuzeichnen();
      }
    });
  }

  /* Nur Begriffe, die ZUR gewaehlten Gruppe gehoeren. Nicht: alle Begriffe der
     Kaffees, die irgendwo in dieser Gruppe liegen -- ein fruchtiger Kaffee hat
     meist auch Kakao und Karamell im Profil, und dann stehen unter "Fruchtig"
     38 Haekchen inklusive Rauch und Milchschokolade. Mit der Zuordnung aus
     daten.gruppenbegriffe sind es 18, und sie sind fruchtig.
     Der Gruppenname selbst fliegt raus -- ein Haekchen "Fruchtig" innerhalb
     der Fruchtig-Verfeinerung sagt nichts. Untergruppen wie "Beeren" oder
     "Zitrus" bleiben, das sind echte Wuensche. */
  function verfeinerungsWerte(kaffees, zustand, daten) {
    var erlaubteGruppen = zustand.gruppen.length
      ? zustand.gruppen : daten.gruppenreihenfolge;
    var ausGruppe = [];
    erlaubteGruppen.forEach(function (g) {
      (daten.gruppenbegriffe[g] || []).forEach(function (begriff) {
        if (begriff !== g && ausGruppe.indexOf(begriff) === -1) ausGruppe.push(begriff);
      });
    });

    /* Nur anbieten, was im Bestand auch vorkommt. */
    var erlaubteNoten = [];
    kaffees.forEach(function (k) {
      (k.noten || []).forEach(function (n) {
        if (ausGruppe.indexOf(n) !== -1 && erlaubteNoten.indexOf(n) === -1) {
          erlaubteNoten.push(n);
        }
      });
    });

    function werte(auslesen) {
      var gesammelt = [];
      kaffees.forEach(function (k) {
        [].concat(auslesen(k) || []).forEach(function (w) {
          if (w && gesammelt.indexOf(w) === -1) gesammelt.push(w);
        });
      });
      return gesammelt.sort();
    }

    return {
      noten: erlaubteNoten.sort(),
      roestgrad: ['Hell', 'Mittel', 'Dunkel'],
      aufbereitung: werte(function (k) { return k.aufbereitung; }),
      mischung: werte(function (k) { return k.mischung; }),
      laender: werte(function (k) { return k.laender; }),
      roesterei: werte(function (k) { return k.roesterei; })
    };
  }

  var VERFEINERUNG_TITEL = {
    noten: 'Geschmack schärfen',
    roestgrad: 'Röstgrad',
    aufbereitung: 'Aufbereitung',
    mischung: 'Single Origin oder Blend',
    laender: 'Herkunft',
    roesterei: 'Rösterei'
  };

  /* Gleichwinklige Projektion -- fuer 16 Punkte ohne Landumrisse voellig
     ausreichend und ohne Fremdbibliothek. Die Karte zeigt nur Laender, die
     in der aktuellen Ergebnisliste vorkommen, mit Trefferzahl: eine Karte
     mit Punkten, die ins Leere fuehren, ist keine Hilfe.
     Punkte sind <button>, damit die Karte per Tastatur bedienbar ist. */
  /* Der Kartengrund. Bisher lagen die Punkte auf einer leeren grauen Flaeche --
     eine Weltkarte ohne Welt. Die Umrisse sind bewusst grob: bei 16 Punkten
     zaehlt die Wiedererkennung, nicht die Kuestenlinie.

     Das viewBox ist 360x180, also direkt Laengen- und Breitengrad:
     x = lon + 180, y = 90 - lat. Dieselbe gleichwinklige Projektion, mit der
     die Punkte in Prozent gesetzt werden -- deshalb passen beide zusammen.

     Die drei Linien sind kein Zierrat: Kaffee waechst zwischen den
     Wendekreisen. Wer die Punkte alle im selben Band liegen sieht, versteht
     das ohne einen Satz Erklaerung. */
  var KARTE_UMRISSE = [
    /* Nordamerika */
    '12,25 40,20 80,18 105,18 125,30 128,43 114,46 100,58 83,64 75,70 63,58 55,42 40,30',
    /* Mittelamerika */
    '75,70 88,74 97,81 103,82 96,75 85,71',
    /* Suedamerika */
    '99,80 110,78 120,85 130,90 145,96 145,113 132,115 127,124 122,130 115,145 108,143 110,130 104,105 99,95',
    /* Afrika */
    '163,75 170,62 180,58 191,53 205,58 214,60 223,78 231,78 222,92 220,105 213,116 205,124 198,125 192,96 188,86 172,85',
    /* Europa und Asien */
    '170,54 180,46 192,44 208,45 220,50 230,50 240,60 248,66 260,70 272,68 280,76 285,70 290,70 302,60 307,55 315,55 321,45 325,45 323,37 340,30 350,24 360,22 360,18 320,15 280,12 240,18 210,20 185,28 175,32 170,40',
    /* Australien */
    '293,112 301,109 310,102 317,102 322,101 326,109 330,115 333,118 330,128 326,129 317,125 309,122 295,124 293,116'
  ];

  /* Der Kaffeeguertel: das Band zwischen den Wendekreisen, in dem praktisch
     aller Kaffee waechst. Vorher standen dort "Wendekreis des Krebses" und
     "Wendekreis des Steinbocks" -- korrekt, aber Erdkundeunterricht. Gemeint
     ist der Guertel, also heisst er auch so. Die Wendekreise bleiben als
     Bandgrenzen sichtbar, nur unbeschriftet. */
  var GUERTEL = { oben: 66.5, unten: 113.5 };
  var AEQUATOR = 90;

  function kartengrund() {
    var svg = '<svg class="lbkf__karte-grund" viewBox="0 0 360 180" ' +
      'preserveAspectRatio="xMidYMid meet" aria-hidden="true" focusable="false">';
    KARTE_UMRISSE.forEach(function (punkte) {
      svg += '<polygon class="lbkf__land" points="' + punkte + '"></polygon>';
    });
    svg += '<rect class="lbkf__guertel" x="0" y="' + GUERTEL.oben +
      '" width="360" height="' + (GUERTEL.unten - GUERTEL.oben) + '"></rect>' +
      '<line class="lbkf__breitengrad" x1="0" x2="360" y1="' + GUERTEL.oben +
      '" y2="' + GUERTEL.oben + '"></line>' +
      '<line class="lbkf__breitengrad" x1="0" x2="360" y1="' + GUERTEL.unten +
      '" y2="' + GUERTEL.unten + '"></line>' +
      '<line class="lbkf__aequator" x1="0" x2="360" y1="' + AEQUATOR +
      '" y2="' + AEQUATOR + '"></line>' +
      '<text class="lbkf__guertel-text" x="4" y="' + (GUERTEL.oben - 3) +
      '">Kaffeegürtel — hier wächst praktisch aller Kaffee</text>';
    return svg + '</svg>';
  }

  function weltkarte(kaffees, zustand, laender) {
    var vorhanden = {};
    kaffees.forEach(function (k) {
      if (!L.erfuelltHart(k, zustand)) return;
      (k.laender || []).forEach(function (name) {
        vorhanden[name] = (vorhanden[name] || 0) + 1;
      });
    });
    var namen = Object.keys(vorhanden).filter(function (n) { return laender[n]; });
    if (!namen.length) return '';

    var punkte = namen.map(function (name) {
      var land = laender[name];
      var x = (land.lon + 180) / 360 * 100;
      var y = (90 - land.lat) / 180 * 100;
      var gesetzt = zustand.laender.indexOf(name) !== -1;
      return '<button type="button" class="lbkf__punkt' +
        (gesetzt ? ' lbkf__punkt--an' : '') + '" data-land="' + text(name) + '"' +
        ' style="left:' + text(x.toFixed(2)) + '%;top:' + text(y.toFixed(2)) + '%"' +
        ' title="' + text(name + ' (' + vorhanden[name] + ')') + '">' +
        '<span class="visually-hidden">' + text(name) + ', ' + text(vorhanden[name]) +
        ' Kaffees</span></button>';
    }).join('');

    var offen = zustand.laender.filter(function (n) { return laender[n]; });
    var texte = offen.map(function (name) {
      var land = laender[name];
      return '<div class="lbkf__landtext"><h4>' + text(name) + '</h4>' +
        (land.rolle ? '<p class="lbkf__landrolle">' + text(land.rolle) + '</p>' : '') +
        (land.stehtFuer ? '<p>' + text(land.stehtFuer) + '</p>' : '') + '</div>';
    }).join('');

    return '<section class="lbkf__karte-block">' +
      '<h3>Woher sie kommen</h3>' +
      '<div class="lbkf__karte" data-lbkf-karte>' + kartengrund() + punkte + '</div>' +
      texte + '</section>';
  }

  function zeichneVerfeinerung(wurzel) {
    var z = wurzel.lbkfZustand;
    var daten = wurzel.lbkfDaten;
    var huelle = wurzel.querySelector('[data-lbkf-verfeinern]');
    var ziel = wurzel.querySelector('[data-lbkf-verfeinerung]');
    var fertig = z.geraete.length && z.gruppen.length && z.staerkewunsch;

    huelle.hidden = !fertig;
    if (!fertig) { ziel.innerHTML = ''; return; }

    var werte = verfeinerungsWerte(daten.kaffees, z, daten);
    var html = '';

    Object.keys(VERFEINERUNG_TITEL).forEach(function (feld) {
      if (!werte[feld].length) return;
      html += '<fieldset class="lbkf__vgruppe" data-vfeld="' + text(feld) + '">' +
        '<legend>' + text(VERFEINERUNG_TITEL[feld]) + '</legend>';
      werte[feld].forEach(function (wert) {
        var gesetzt = z[feld].indexOf(wert) !== -1;
        /* Trefferzahl fuer diese Option zusaetzlich zum jetzigen Zustand.
           Was auf null fuehrt, ist ausgegraut mit der Zahl 0 -- sichtbar
           leer, nicht fehlend. So kann sich niemand in eine leere
           Ergebnisseite klicken. */
        var aenderung = {};
        aenderung[feld] = gesetzt ? z[feld] : z[feld].concat([wert]);
        var treffer = L.zaehle(daten.kaffees, z, aenderung);
        html += '<label class="lbkf__voption' + (treffer ? '' : ' lbkf__voption--leer') + '">' +
          '<input type="checkbox" value="' + text(wert) + '"' +
          (gesetzt ? ' checked' : '') + (treffer ? '' : ' disabled') + '>' +
          '<span>' + text(wert) + ' (' + text(treffer) + ')</span></label>';
      });
      html += '</fieldset>';
    });

    /* Preisdeckel: beide Enden kommen aus dem Bestand, nicht aus der Luft.
       Der untere Anschlag stand fest auf 10 -- liegt der guenstigste Kaffee
       darueber (er kostet 22,90), liess sich der Regler ins Leere ziehen. Das
       widerspricht der Kernregel dieser Ebene: Man soll sich nicht in eine
       leere Liste klicken koennen. Also ist der Anschlag der guenstigste
       Kaffee, der die uebrigen Bedingungen erfuellt -- damit bleibt an jeder
       Reglerstellung mindestens einer uebrig. */
    var ohnePreis = {};
    for (var feld in z) { ohnePreis[feld] = z[feld]; }
    ohnePreis.preisMax = null;
    var moegliche = [];
    daten.kaffees.forEach(function (k) {
      if (typeof k.euroProKg === 'number' && L.erfuelltHart(k, ohnePreis)) {
        moegliche.push(k.euroProKg);
      }
    });
    if (moegliche.length) {
      var hoechst = Math.ceil(Math.max.apply(null, moegliche));
      /* Aufrunden, nicht abrunden: Der guenstigste kostet z. B. 28,40. Ein
         Anschlag bei 28 schloesse ihn aus, weil 28,40 > 28 -- und der
         unterste Reglerwert zeigte auf eine leere Liste. Genau der Fehler,
         den dieser Anschlag verhindern soll. */
      var billigst = Math.ceil(Math.min.apply(null, moegliche));
      var jetzt = z.preisMax === null || z.preisMax === undefined ? hoechst : z.preisMax;
      var preisTreffer = L.zaehle(daten.kaffees, z, { preisMax: jetzt });
      html += '<fieldset class="lbkf__vgruppe" data-vfeld="preisMax">' +
        '<legend>Preis pro Kilo, höchstens</legend>' +
        '<input type="range" min="' + text(billigst) + '" max="' + text(hoechst) +
        '" step="1" value="' + text(jetzt) + '" data-lbkf-preis-regler>' +
        '<output>' + text(jetzt) + ' € / kg (' + text(preisTreffer) + ')</output>' +
        (z.preisMax !== null && z.preisMax !== undefined
          ? ' <button type="button" data-lbkf-preis-aus>Grenze aufheben</button>' : '') +
        '</fieldset>';
    }

    /* Derselbe Zustand wie der Schalter ganz oben, nur hier ebenfalls
       bedienbar -- ein Zustand an zwei Stellen, nicht zwei Schalter.
       Deshalb steht die Trefferzahl daneben. */
    /* Zwei Zahlen mit verschiedenem Zweck: Die eine sagt, was das Umlegen
       braechte (fuer die Sperre), die andere, was der Haken gerade zeigt.
       Vorher stand am eingeschalteten Haken die Zahl der KOFFEINHALTIGEN --
       "Nur entkoffeiniert (83)" ueber einer Liste mit acht Treffern. */
    var decafWaereDann = L.zaehle(daten.kaffees, z, { koffeinfrei: !z.koffeinfrei });
    var decafTreffer = z.koffeinfrei
      ? L.zaehle(daten.kaffees, z, {})
      : decafWaereDann;
    /* Auch dieser Schalter faellt unter die Null-Regel. Wer die Auswahl auf
       eine Roesterei ohne Entkoffeinierte eingeengt hat, konnte ihn vorher
       trotzdem umlegen und landete auf einer leeren Liste. Ausgeschaltet wird
       nur gesperrt, wenn das Umlegen nichts brechte -- ausgeschaltet muss er
       immer bedienbar bleiben, sonst kaeme man aus dem leeren Zustand nicht
       wieder heraus. */
    var decafSperre = decafWaereDann === 0 && !z.koffeinfrei;
    html += '<fieldset class="lbkf__vgruppe" data-vfeld="koffeinfrei">' +
      '<legend>Rahmen</legend>' +
      '<label class="lbkf__voption' + (decafSperre ? ' lbkf__voption--leer' : '') + '">' +
      '<input type="checkbox" data-lbkf-koffeinfrei' + (z.koffeinfrei ? ' checked' : '') +
      (decafSperre ? ' disabled' : '') + '>' +
      '<span>Nur entkoffeiniert (' + text(decafTreffer) + ')</span></label>' +
      '</fieldset>';

    html += weltkarte(daten.kaffees, z, daten.laender);

    ziel.innerHTML = html;
  }

  function verdrahteVerfeinerung(wurzel) {
    var ziel = wurzel.querySelector('[data-lbkf-verfeinerung]');

    ziel.addEventListener('change', function (e) {
      var gruppe = e.target.closest('[data-vfeld]');
      if (!gruppe) return;
      var feld = gruppe.dataset.vfeld;
      if (e.target.matches('[data-lbkf-preis-regler]')) {
        wurzel.lbkfZustand.preisMax = parseFloat(e.target.value);
      } else if (e.target.matches('[data-lbkf-koffeinfrei]')) {
        wurzel.lbkfZustand.koffeinfrei = e.target.checked;
      } else if (e.target.type === 'checkbox') {
        umschalten(wurzel.lbkfZustand[feld], e.target.value);
      }
      wurzel.lbkfNeuzeichnen();
    });

    ziel.addEventListener('click', function (e) {
      if (e.target.matches('[data-lbkf-preis-aus]')) {
        wurzel.lbkfZustand.preisMax = null;
        wurzel.lbkfNeuzeichnen();
      }
      var punkt = e.target.closest('[data-land]');
      if (punkt) {
        umschalten(wurzel.lbkfZustand.laender, punkt.dataset.land);
        wurzel.lbkfNeuzeichnen();
      }
    });

  }

  function starte(wurzel) {
    var status = wurzel.querySelector('[data-lbkf-status]');

    fetch(wurzel.dataset.daten, { credentials: 'same-origin' })
      .then(function (antwort) {
        if (!antwort.ok) throw new Error('HTTP ' + antwort.status);
        return antwort.json();
      })
      .then(function (daten) {
        wurzel.lbkfDaten = daten;
        wurzel.lbkfZustand = zustandAusAdresse();

        wurzel.lbkfNeuzeichnen = function () {
          /* Das Neuzeichnen ersetzt den Frageblock komplett und wuerfe damit
             den Tastaturfokus weg -- wer sich durchtabbt, landete nach jedem
             Klick wieder am Seitenanfang. Deshalb vorher merken, hinterher
             zurueckgeben. */
          var aktiv = document.activeElement;
          /* Auch die Verfeinerung merken, nicht nur die Fragen. Sonst fiel der
             Fokus bei jeder Bedienung auf den Seitenanfang -- am schlimmsten
             beim Preisregler, wo jeder Pfeiltastendruck ein Neuzeichnen
             ausloest und der naechste Druck dann die Seite scrollte. */
          var behaelter = aktiv && wurzel.contains(aktiv)
            ? aktiv.closest('[data-feld], [data-vfeld]') : null;
          var merkmal = behaelter
            ? { bereich: behaelter.dataset.feld ? 'data-feld' : 'data-vfeld',
                feld: behaelter.dataset.feld || behaelter.dataset.vfeld,
                wert: aktiv.dataset ? (aktiv.dataset.wert || aktiv.value) : null }
            : null;

          zeichneFragen(wurzel);
          zeichneVerfeinerung(wurzel);
          adresseAusZustand(wurzel.lbkfZustand);
          zeigeErgebnis(wurzel);

          if (merkmal && merkmal.feld) {
            var rumpf = '[' + merkmal.bereich + '="' + merkmal.feld + '"] ';
            var wahl = merkmal.wert
              ? rumpf + '[data-wert="' + merkmal.wert + '"], ' +
                rumpf + '[value="' + merkmal.wert + '"]'
              : rumpf + 'input';
            var neu = wurzel.querySelector(wahl);
            if (neu) neu.focus();
          }
        };

        zeichneFragen(wurzel);
        /* Erst hier, nicht schon beim Laden des Skripts: gemeldet wird der
           benutzbare Finder, nicht der Versuch. Wer die Datendatei nicht
           bekommt, sieht den Fehlerhinweis und faellt aus dem Trichter --
           richtig so, er hat den Finder nie gehabt. */
        meldeSchritt('geoeffnet');
        /* Auch beim ersten Aufbau zeichnen, nicht erst beim naechsten
           lbkfNeuzeichnen -- sonst bleibt die Verfeinerung nach einem
           Neuladen mit vollstaendiger Adresszeile unsichtbar, obwohl der
           Zustand laengst wiederhergestellt ist. */
        zeichneVerfeinerung(wurzel);
        verdrahteFragen(wurzel);
        verdrahteVerfeinerung(wurzel);
        /* Haekchen aendern nur die Summe, nicht die Ergebnisliste. Ein
           Neuzeichnen wuerde die Bestandspruefung erneut ausloesen und die
           Auswahl verlieren. */
        wurzel.querySelector('[data-lbkf-ergebnis]').addEventListener('change', function (e) {
          if (e.target.matches('[data-lbkf-waehlen]')) {
            merkeAuswahl(wurzel);
            aktualisiereSumme(wurzel);
          }
        });
        wurzel.querySelector('[data-lbkf-ergebnis]').addEventListener('click', function (e) {
          /* Der zweite und vermutlich haeufigere Kaufweg: raus aus dem
             Ergebnis auf eine Produktseite und dort kaufen. Ohne Merkmal
             waere dieser Weg unsichtbar. Der Klick wird nicht aufgehalten --
             die Anfrage traegt keepalive und ueberlebt den Seitenwechsel. */
          if (e.target.closest('a[href^="/products/"]')) {
            merkeHerkunft('Empfehlung', true);
            return;
          }
          var einzeln = e.target.closest('[data-lbkf-einzeln]');
          if (einzeln) {
            legeEinzelnInDenWarenkorb(wurzel, einzeln);
            return;
          }
          if (e.target.closest('[data-lbkf-kaufen]')) {
            legeAuswahlInDenWarenkorb(wurzel);
            return;
          }
          if (e.target.closest('[data-lbkf-oben]')) {
            wurzel.querySelector('[data-lbkf-fragen]').scrollIntoView({ behavior: 'smooth' });
            return;
          }
          var lockern = e.target.closest('[data-lbkf-lockern]');
          if (lockern) {
            var feld = lockern.dataset.lbkfLockern;
            wurzel.lbkfZustand[feld] = feld === 'preisMax' ? null : [];
            wurzel.lbkfNeuzeichnen();
            return;
          }
          var mehr = e.target.closest('[data-lbkf-mehr]');
          if (mehr) {
            var liste = wurzel.querySelector('[data-lbkf-rest]');
            var offen = mehr.getAttribute('aria-expanded') === 'true';
            liste.hidden = offen;
            mehr.setAttribute('aria-expanded', offen ? 'false' : 'true');
            if (!mehr.dataset.zu) mehr.dataset.zu = mehr.textContent;
            mehr.textContent = offen ? mehr.dataset.zu : 'Weniger zeigen';
          }
        });
        zeigeErgebnis(wurzel);
      })
      .catch(function (fehler) {
        /* Sichtbar scheitern, nicht still. Ein leerer Berater ohne Hinweis
           ist schlimmer als ein Hinweis. */
        var ziel = wurzel.dataset.kollektion || '/collections/kaffee';
        status.innerHTML = 'Der Kaffeefinder konnte nicht geladen werden. ' +
          '<a href="' + ziel + '">Hier gehts zu allen Kaffees.</a>';
        if (window.console) console.error('Kaffeefinder:', fehler);
      });
  }

  /* Dieselbe Geometrie wie snippets/lb-aromarosette.liquid -- acht Segmente,
     Radreihenfolge, 45 Grad Schritt. Die Farben kommen aus der Datendatei
     und damit aus lb-aroma-zuordnung.liquid, also aus derselben Quelle wie
     die Rosette auf der Produktseite. Nur die Geometrie steht zweimal, und
     die aendert sich nicht.
     Warum nachgebaut und nicht das Snippet benutzt: die Ergebnisliste
     entsteht im Browser, Liquid laeuft dort nicht. */
  function rosette(gruppen, alleGruppen, farben, groesse) {
    gruppen = gruppen || [];
    var svg = '<svg class="lbkf__rosette" width="' + groesse + '" height="' + groesse +
      '" viewBox="0 0 100 100" role="img" aria-label="Aromagruppen: ' +
      text(gruppen.join(', ') || 'keine Angabe') + '">';
    alleGruppen.forEach(function (gruppe, i) {
      var an = gruppen.indexOf(gruppe) !== -1;
      svg += '<circle cx="50" cy="50" r="40" fill="none" stroke-width="13"' +
        ' stroke-dasharray="26.4 224.93" transform="rotate(' + (i * 45 - 90) + ' 50 50)"' +
        ' stroke="' + (an ? text(farben[gruppe]) : 'rgba(var(--color-foreground), 0.13)') + '"></circle>';
    });
    return svg + '</svg>';
  }

  var ANTEIL_WORT = [
    { ab: 1,    wort: 'genau richtig' },
    { ab: 0.6,  wort: 'eine Stufe daneben' },
    { ab: 0.2,  wort: 'zwei Stufen daneben' },
    { ab: 0,    wort: 'passt hier nicht' }
  ];

  function anteilWort(anteil) {
    for (var i = 0; i < ANTEIL_WORT.length; i++) {
      if (anteil >= ANTEIL_WORT[i].ab) return ANTEIL_WORT[i].wort;
    }
    return ANTEIL_WORT[ANTEIL_WORT.length - 1].wort;
  }

  /* Die Begruendung nennt auch, was nicht passt. Eine Liste, die nur lobt,
     ist Werbung; eine, die den Abstand benennt, ist Beratung. */
  function begruendung(eintrag, zustand) {
    var k = eintrag.kaffee;
    var w = eintrag.wertung;
    var ziel = L.zielwerte(zustand);
    var zeilen = [];

    /* Ein Kaffee ohne gepflegte Noten ist laut Logikdatei ausdruecklich
       zulaessig -- dann darf die Oberflaeche nicht daran zerbrechen. */
    var gruppen = k.gruppen || [];
    var noten = k.noten || [];
    var getroffen = gruppen.filter(function (g) { return zustand.gruppen.indexOf(g) !== -1; });
    zeilen.push({
      achse: 'Aroma',
      text: (noten.slice(0, 3).join(', ') || gruppen.join(', ') || 'keine Angabe') +
        (getroffen.length
          ? ' — trifft ' + (getroffen.length === 1
              ? 'deine Richtung' : getroffen.length + ' deiner Richtungen')
          : ' — nicht deine gewählte Richtung')
    });

    if (k.roestgrad) {
      zeilen.push({
        achse: 'Röstung',
        text: k.roestgrad.toLowerCase() + ' — ' +
          (w.roestgrad >= 1 ? 'genau richtig für deine Tasse' : anteilWort(w.roestgrad))
      });
    }

    if (typeof k.staerke === 'number') {
      var abstand = k.staerke - ziel.staerke;
      var satz;
      if (Math.abs(abstand) <= 0.5) satz = 'genau dein Bereich';
      else if (abstand > 0) satz = 'kräftiger als gewünscht';
      else satz = 'milder als gewünscht';
      zeilen.push({ achse: 'Stärke', text: k.staerke + ' von 5 — ' + satz });
    }

    if (zustand.zucker && k.gruppen.indexOf('Süß') !== -1) {
      zeilen.push({
        achse: 'Zucker',
        text: 'bringt eigene Süße mit — du brauchst vielleicht weniger als sonst'
      });
    }
    return zeilen;
  }

  /* Preise und Verfuegbarkeit kommen live. Die Datendatei kennt euroProKg nur
     zum Filtern -- ein aus einer eingecheckten Datei angezeigter Preis waere
     irgendwann falsch, und das ist nach PAngV kein Schoenheitsfehler.

     Derselbe Abruf beantwortet die zweite Frage: Gibt es den Kaffee noch?
     Die Datendatei ist ein Standbild vom Erzeugungstag. Ausverkauft heisst
     kurzfristig weg und wird weiter empfohlen; aus dem Sortiment genommen
     heisst tote Produktseite und darf nicht empfohlen werden. In den Daten
     sehen beide Faelle gleich aus, im Shop nicht. */
  function holeStand(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js',
                 { credentials: 'same-origin' })
      .then(function (antwort) {
        /* 404 = aus dem Sortiment. Andere Fehlerantworten sagen nichts ueber
           das Sortiment aus und duerfen keine Empfehlung verschlucken. */
        if (antwort.status === 404) return { weg: true };
        if (!antwort.ok) return null;
        return antwort.json().then(function (produkt) {
          if (!produkt || !produkt.variants) return null;
          var ganze = produkt.variants.filter(function (v) {
            return v.available && /250/.test(v.title) && /ganze/i.test(v.title);
          });
          var variante = ganze[0] ||
            produkt.variants.filter(function (v) { return v.available; })[0];
          if (!variante) return { weg: false, verfuegbar: false };
          /* Der Shop liefert die Optionen benannt (Packungsgroesse, Roestdatum,
             Mahlgrad). Deshalb nicht den Variantentitel durchreichen -- der
             liest sich sonst als "250 Gramm / 06.07.2026" mitten in der
             Preiszeile. Das Roestdatum ist gepflegte Frischeinformation und
             bekommt eine eigene Zeile. */
          var namen = (produkt.options || []).map(function (o) {
            return typeof o === 'string' ? o : (o && o.name) || '';
          });
          var werte = variante.options || [];
          var beschriftung = [];
          var roestdatum = null;
          werte.forEach(function (wert, i) {
            var name = (namen[i] || '').toLowerCase();
            if (name.indexOf('röstdatum') !== -1 || name.indexOf('roestdatum') !== -1) {
              roestdatum = wert;
            } else if (wert) {
              beschriftung.push(wert);
            }
          });
          return {
            weg: false,
            verfuegbar: true,
            variantenId: variante.id,
            variantenName: beschriftung.length
              ? beschriftung.join(', ') : variante.title,
            roestdatum: roestdatum,
            preis: variante.price,
            grundpreis: variante.unit_price,
            /* Shopify liefert unit_price als Preis je reference_value +
               reference_unit. Nur die Einheit zu nehmen ergibt bei "je 100 g"
               einen um den Faktor 100 falschen Grundpreis -- und eine
               geratene Einheit hat in einer Pflichtangabe nichts verloren. */
            grundpreisEinheit: variante.unit_price_measurement
              ? ((variante.unit_price_measurement.reference_value &&
                  variante.unit_price_measurement.reference_value !== 1
                    ? variante.unit_price_measurement.reference_value + ' ' : '') +
                 (variante.unit_price_measurement.reference_unit || ''))
              : null
          };
        });
      })
      /* Netzwerkfehler: Zustand unbekannt, Kaffee bleibt drin. */
      .catch(function () { return null; });
  }

  /* Sechzehn pruefen, damit nach dem Aussortieren und dem Zurueckstellen der
     ausverkauften noch zehn uebrig sind. */
  var GEPRUEFT = 16;
  var GEZEIGT = 10;

  /* Ausverkaufte rutschen hinter alle lieferbaren, die Reihenfolge nach
     Passung bleibt in beiden Gruppen erhalten. Bis 03.10.2026 stand ein leerer
     Kaffee als "Beste Passung" ganz oben -- das wichtigste Feld der Seite bot
     nichts zum Kaufen an.
     Das ist kein Standbild: holeStand fragt bei JEDEM Ergebnis live nach. Kommt
     morgen Ware, steht der Kaffee beim naechsten Aufruf wieder vorn -- ohne
     neue Datendatei, ohne Deploy. Unbekannter Stand (Netzfehler) zaehlt als
     lieferbar, damit ein Wackler keine Empfehlung nach hinten schiebt. */
  function pruefeBestand(liste) {
    var kandidaten = liste.slice(0, GEPRUEFT);
    return Promise.all(kandidaten.map(function (e) {
      return holeStand(e.kaffee.handle);
    })).then(function (staende) {
      var lieferbar = [];
      var leer = [];
      kandidaten.forEach(function (eintrag, i) {
        var stand = staende[i];
        if (stand && stand.weg) return;
        eintrag.stand = stand;
        (stand && !stand.verfuegbar ? leer : lieferbar).push(eintrag);
      });
      return lieferbar.concat(leer).slice(0, GEZEIGT);
    });
  }

  function istKaufbar(eintrag) {
    return !!(eintrag.stand && eintrag.stand.verfuegbar);
  }

  /* Die drei Plaetze ganz oben, jeder mit eigener Rolle: beste Passung,
     Preis-Leistungs-Tipp, Geheimtipp. Drei fast gleiche Treffer mit 86 bis
     87 Prozent waren austauschbar; drei Rollen geben jedem Platz einen Grund.
     Gibt es keinen Tipp (Regeln siehe unten), rueckt die naechstbeste
     Passung nach -- ohne Abzeichen, das sie nicht verdient hat.
     Nur aus kaufbaren Kaffees: jede dieser Karten hat einen Kaufknopf. */
  var ROLLEN = {
    beste: 'Beste Passung',
    preis: 'Preis-Leistungs-Tipp',
    geheim: 'Geheimtipp',
    auch: 'Passt auch'
  };

  /* Fuer die Rollen oben gilt ein Massstab relativ zur besten Passung, nicht
     die festen 85 Prozent aus L.geheimtipp/L.preistipp. Gemessen
     am 03.10.2026 an fuenf typischen Antworten: Mit den festen Regeln gab es
     fast nie einen Preis-Tipp, und der Geheimtipp war meist die beste Passung
     selbst -- oben standen dann zweimal "Passt auch".
     Kandidat ist, wer hoechstens ABSTAND Punkte unter der besten Passung liegt
     und mindestens BODEN erreicht. Darunter waere "Tipp" ein leeres Wort. */
  var TRIO_ABSTAND = 10;
  var TRIO_BODEN = 70;
  var TRIO_GUENSTIGER = 0.9;   /* Preis-Tipp: mind. 10 % unter der besten je kg */
  var GEHEIM_AB_RANG = 40;     /* wie TIPP_MINDESTRANG in der Logikdatei */

  function spitzenTrio(kaufbar) {
    if (!kaufbar.length) return [];
    var beste = kaufbar[0];
    var trio = [{ eintrag: beste, rolle: 'beste' }];
    var grenze = Math.max(TRIO_BODEN, beste.wertung.passung - TRIO_ABSTAND);

    function drin(eintrag) {
      return trio.some(function (t) { return t.eintrag === eintrag; });
    }
    var nah = kaufbar.filter(function (e) {
      return !drin(e) && e.wertung.passung >= grenze;
    });

    var preis = null;
    if (typeof beste.kaffee.euroProKg === 'number') {
      nah.forEach(function (e) {
        var kg = e.kaffee.euroProKg;
        if (typeof kg !== 'number' || kg > beste.kaffee.euroProKg * TRIO_GUENSTIGER) return;
        if (!preis || kg < preis.kaffee.euroProKg) preis = e;
      });
    }
    if (preis) trio.push({ eintrag: preis, rolle: 'preis' });

    /* nah ist nach Passung sortiert -- der erste Wenigverkaufte ist der beste. */
    var geheim = nah.filter(function (e) {
      return !drin(e) && typeof e.kaffee.rang === 'number' && e.kaffee.rang > GEHEIM_AB_RANG;
    })[0];
    if (geheim) trio.push({ eintrag: geheim, rolle: 'geheim' });

    for (var i = 0; i < kaufbar.length && trio.length < 3; i++) {
      if (!drin(kaufbar[i])) trio.push({ eintrag: kaufbar[i], rolle: 'auch' });
    }
    return trio;
  }

  function geld(cent, waehrung) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency', currency: waehrung || 'EUR'
    }).format(cent / 100);
  }

  /* Unter 60 Prozent nicht "leider nichts gefunden", sondern der
     naechstbeste Treffer plus der Hinweis, welche Lockerung am meisten
     bringt. Rechenbar, weil alle Kaffees im Browser liegen. */
  var SCHWELLE_KNAPP = 60;

  function lockerungsHinweis(wurzel, liste) {
    var z = wurzel.lbkfZustand;
    var daten = wurzel.lbkfDaten;
    if (liste.length && liste[0].wertung.passung >= SCHWELLE_KNAPP) return '';

    var vorschlag = L.lockerung(daten.kaffees, z);
    var html = '<aside class="lbkf__knapp"><h3>';
    html += liste.length
      ? 'Wirklich gut passt hier nichts'
      : 'Mit dieser Kombination haben wir nichts';
    html += '</h3>';

    if (vorschlag) {
      html += '<p>Wenn du ' + text(vorschlag.beschriftung) +
        ' nachgibst, kommen ' + vorschlag.gewinn +
        (vorschlag.gewinn === 1 ? ' weiterer Kaffee' : ' weitere Kaffees') + ' dazu.</p>' +
        '<button type="button" class="btn btn--secondary btn--small" data-lbkf-lockern="' +
        text(vorschlag.feld) + '">' + text(vorschlag.knopf || vorschlag.beschriftung) +
        ' aufheben</button>';
    } else if (liste.length) {
      html += '<p>Der nächstbeste Treffer steht unten — mit dem, was an ihm ' +
        'nicht passt.</p>';
    } else {
      html += '<p>Nimm eine Aromarichtung dazu oder wechsle die Stärke.</p>';
    }
    return html + '</aside>';
  }

  function zeigeErgebnis(wurzel) {
    var z = wurzel.lbkfZustand;
    var daten = wurzel.lbkfDaten;
    var status = wurzel.querySelector('[data-lbkf-status]');
    var ziel = wurzel.querySelector('[data-lbkf-ergebnis]');
    var fertig = z.geraete.length && z.gruppen.length && z.staerkewunsch;

    if (!fertig) {
      /* Kein Ergebnis vor der ersten Antwort. Eine Passungszahl, die
         erscheint bevor etwas eingegeben wurde, ist beim ersten Blick
         bedeutungslos. */
      status.textContent = 'Beantworte die vier Fragen, dann rechnen wir.';
      ziel.innerHTML = '';
      return;
    }

    /* Gemeldet wird, sobald gerechnet werden konnte -- auch wenn die Liste
       leer bleibt. "Kein Treffer" ist ein Ergebnis und gehoert in den
       Trichter; wer es herausrechnet, macht die Sackgassen unsichtbar. */
    meldeSchritt('ergebnis');

    var liste = L.ergebnis(daten.kaffees, z);
    var knapp = lockerungsHinweis(wurzel, liste);

    if (!liste.length) {
      status.textContent = 'Kein Treffer.';
      ziel.innerHTML = knapp;
      return;
    }

    status.textContent = 'Beste Passung: ' + liste[0].wertung.passung + ' %.';
    ziel.innerHTML = '<p class="lbkf__laedt">Wir sehen kurz nach, was gerade da ist …</p>';

    /* Erst den Bestand pruefen, dann zeichnen. Andersherum blitzten Karten
       auf, die es gar nicht mehr gibt. */
    /* Jeder Zeichenlauf bekommt eine Nummer. Ohne sie konnte ein langsamer
       erster Lauf einen schnelleren zweiten ueberschreiben: Wer waehrend der
       Bestandspruefung "nur entkoffeiniert" anhakt, bekam die alte Liste
       zurueck -- mit dem Satz "und brauchst koffeinfrei" darueber, mit
       koffeinhaltigen Kaffees vorgehakt, und ein Klick auf "In den Warenkorb"
       haette genau das eingelegt, was er eben ausgeschlossen hat. */
    wurzel.lbkfLauf = (wurzel.lbkfLauf || 0) + 1;
    var lauf = wurzel.lbkfLauf;

    pruefeBestand(liste).then(function (zehn) {
      if (lauf !== wurzel.lbkfLauf) return;   /* ueberholt, verwerfen */
      if (!zehn.length) {
        status.textContent = 'Diese Treffer sind gerade nicht im Sortiment.';
        ziel.innerHTML = '';
        return;
      }
      zeichneTreffer(wurzel, zehn, knapp);
    }).catch(function (fehler) {
      /* Ohne diesen Zweig blieb die Seite bei einem Fehler fuer immer auf
         "Wir sehen kurz nach ..." stehen -- ohne Erklaerung und ohne Ausweg.
         Nachgestellt mit einem verstuemmelten Parameter in einem geteilten
         Link, und die Adresszeile ist ausdruecklich zum Weiterschicken
         gebaut. */
      if (lauf !== wurzel.lbkfLauf) return;
      var kollektion = wurzel.dataset.kollektion || '/collections/kaffee';
      status.textContent = 'Da ist etwas schiefgelaufen.';
      ziel.innerHTML = '<p class="lbkf__knapp">Wir konnten das Ergebnis nicht ' +
        'zusammenstellen. <a href="' + text(kollektion) + '">Hier gehts zu allen ' +
        'Kaffees.</a> Oder <button type="button" class="lbkf__aendern" ' +
        'data-lbkf-oben>ändere deine Antworten</button>.</p>';
      if (window.console) console.error('Kaffeefinder:', fehler);
    });
  }

  function zeichneTreffer(wurzel, zehn, knapp) {
    var z = wurzel.lbkfZustand;
    var daten = wurzel.lbkfDaten;
    var ziel = wurzel.querySelector('[data-lbkf-ergebnis]');
    var waehrung = wurzel.dataset.shopwaehrung;
    /* Tipps nur aus kaufbaren Kaffees -- ein Tipp auf einen Kaffee, den es
       gerade nicht gibt, waere der schlechteste aller Tipps. */
    var kaufbar = zehn.filter(istKaufbar);
    var trio = spitzenTrio(kaufbar);
    var oben = trio.map(function (t) { return t.eintrag; });
    var rest = zehn.filter(function (e) { return oben.indexOf(e) === -1; });

    /* Was der Kunde selbst angehakt hat, ueberlebt das Neuzeichnen. Vorher
       setzte jede Verfeinerung -- ein Kartenpunkt genuegte -- die Kiste
       kommentarlos auf den Vorschlag zurueck. Nur beim ersten Zeichnen einer
       Antwort greift die Vorauswahl: die drei Karten oben. */
    var bisher = wurzel.lbkfAuswahl || null;
    var vorhanden = kaufbar.map(function (e) { return e.kaffee.handle; });
    var behalten = bisher
      ? bisher.filter(function (h) { return vorhanden.indexOf(h) !== -1; })
      : [];
    var trioHandles = oben.map(function (e) { return e.kaffee.handle; });
    var vorgewaehlt = behalten.length ? behalten : trioHandles;

    var beste = oben[0] || zehn[0];
    wurzel.querySelector('[data-lbkf-status]').textContent =
      'Beste Passung: ' + beste.wertung.passung + ' %.';

    var html = '<p class="lbkf__verstanden">' + verstandenSatz(z) +
      ' <button type="button" class="lbkf__aendern" data-lbkf-oben>Ändern</button></p>';
    html += knapp || '';

    if (trio.length) {
      html += '<ul class="lbkf__spitze" role="list">' +
        trio.map(function (t) {
          return treffer(t.eintrag, z, daten, waehrung, vorgewaehlt, t.rolle);
        }).join('') + '</ul>';
    } else {
      html += '<p class="lbkf__knapp">Gerade ist keiner deiner Treffer lieferbar. ' +
        'Meist dauert das nur ein paar Tage.</p>';
    }

    /* Preis und Variante je Kaffee merken, damit die Summe ohne weiteren
       Abruf gerechnet werden kann. Der Bestand wurde soeben in
       pruefeBestand geholt. */
    wurzel.lbkfPreise = {};
    kaufbar.forEach(function (e) {
      wurzel.lbkfPreise[e.kaffee.handle] = {
        preis: e.stand.preis,
        variantenId: e.stand.variantenId
      };
    });

    /* Die Kiste steht direkt unter den drei Karten, nicht mehr hinter allen
       zehn. Vorher lag der Kaufknopf elf Karten tiefer -- in vier Wochen
       Messung liefen 20 von 23 Finder-Kaeufen ueber "Zum Kaffee", nur 3 ueber
       die Kiste. */
    var kiste = auswahlBlock(zehn, wurzel.dataset.abo,
                             vorauswahlSatz(vorgewaehlt, trioHandles),
                             wurzel.dataset.versandUrl);
    html += kiste;

    /* Der Rest ist eingeklappt, auf jeder Breite. Zehn offene Karten waren
       eine Scrollstrecke zwischen Ergebnis und Kauf. */
    if (rest.length) {
      html += '<button type="button" class="lbkf__mehr" data-lbkf-mehr ' +
        'aria-expanded="false">' + (rest.length === 1
          ? 'Einen weiteren passenden Kaffee zeigen'
          : 'Weitere ' + rest.length + ' passende Kaffees zeigen') + '</button>' +
        '<ul class="lbkf__treffer-liste" role="list" hidden data-lbkf-rest>' +
        rest.map(function (e) {
          return treffer(e, z, daten, waehrung, vorgewaehlt, null);
        }).join('') + '</ul>';
    }
    /* Die Kiste traegt den Pflichthinweis schon, direkt unter den ersten
       Preisen. Nur ohne Kiste braucht es ihn hier. */
    if (!kiste) html += preishinweis(wurzel.dataset.versandUrl);

    /* Das Rezept steht hinter dem Kaufkasten. Es gibt nur sechs Rezepte fuer
       91 Kaffees -- allein "Espresso italienisch 1:3" haengt an 75 davon. Es
       sagt also wenig ueber diesen einen Kaffee und viel ueber die
       Bruehmethode. Zwischen Entscheiden und Kaufen hat es deshalb nichts
       verloren; als Abschluss dagegen schon: die Seite endet beim Gelingen,
       nicht beim Kauf. */
    html += rezeptBlock(passendesRezept(beste.kaffee, z, daten.rezepte),
                        beste.kaffee.titel);

    /* Leiste am unteren Rand: erscheint erst, wenn die Kiste nach oben aus dem
       Bild gescrollt ist -- also beim Stoebern in den weiteren Kaffees. */
    html += '<div class="lbkf__leiste" data-lbkf-leiste hidden>' +
      '<span class="lbkf__leiste-text" data-lbkf-leiste-text></span>' +
      '<button type="button" class="btn btn--primary btn--small" data-lbkf-kaufen>' +
      'In den Warenkorb</button></div>';
    html += '<p class="visually-hidden" role="status" aria-live="polite" data-lbkf-ansage></p>';

    ziel.innerHTML = html;
    merkeAuswahl(wurzel);
    aktualisiereSumme(wurzel);
    beobachteKiste(wurzel);
  }

  function beobachteKiste(wurzel) {
    if (wurzel.lbkfBeobachter) wurzel.lbkfBeobachter.disconnect();
    var kiste = wurzel.querySelector('[data-lbkf-auswahl]');
    var leiste = wurzel.querySelector('[data-lbkf-leiste]');
    if (!kiste || !leiste || !('IntersectionObserver' in window)) return;
    wurzel.lbkfBeobachter = new IntersectionObserver(function (eintraege) {
      var e = eintraege[0];
      wurzel.lbkfKisteVorbei = !e.isIntersecting && e.boundingClientRect.top < 0;
      zeigeLeiste(wurzel);
    });
    wurzel.lbkfBeobachter.observe(kiste);
  }

  function zeigeLeiste(wurzel) {
    var leiste = wurzel.querySelector('[data-lbkf-leiste]');
    if (!leiste) return;
    var gewaehlt = wurzel.querySelectorAll('[data-lbkf-waehlen]:checked').length;
    leiste.hidden = !(wurzel.lbkfKisteVorbei && gewaehlt);
  }

  /* Die gesetzten Haekchen festhalten, damit sie das naechste Neuzeichnen
     ueberstehen. */
  function merkeAuswahl(wurzel) {
    var gesetzt = [];
    wurzel.querySelectorAll('[data-lbkf-waehlen]').forEach(function (feld) {
      if (feld.checked) gesetzt.push(feld.dataset.lbkfWaehlen);
    });
    wurzel.lbkfAuswahl = gesetzt;
  }

  function verstandenSatz(z) {
    var geraete = z.geraete.map(function (id) {
      var g = L.GERAETE.filter(function (x) { return x.id === id; })[0];
      return g ? g.label : id;
    });
    var teile = ['Du brühst mit ' + geraete.join(' und ')];
    if (z.zubereitung.length) {
      teile.push('trinkst ihn als ' + z.zubereitung.map(function (id) {
        /* Unbekannte Werte kommen aus geteilten Links, die unterwegs
           beschaedigt wurden. Sie duerfen die Seite nicht toeten. */
        return (L.ZUBEREITUNGEN[id] || {}).label || id;
      }).join(' und '));
    }
    teile.push('magst es ' + z.gruppen.join(' und ').toLowerCase());
    if (z.staerkewunsch) {
      teile.push(((L.STAERKEWUNSCH[z.staerkewunsch] || {}).label ||
                  z.staerkewunsch).toLowerCase());
    }
    if (z.koffeinfrei) teile.push('und brauchst koffeinfrei');
    return text(teile.join(', ') + '.');
  }

  /* Abzeichen ohne Punkte in der Bewertung. "Neu bei uns" absichtlich nicht
     als Gewicht: sonst schiebt sich Neues nach oben, ohne besser zu passen.
     Preis- und Geheimtipp sind seit 03.10.2026 Rollen der drei Karten oben
     (spitzenTrio), keine Abzeichen mehr -- sonst stand "Preis-Leistungs-Tipp"
     oben als Rolle und unten zugleich als Abzeichen an einem anderen Kaffee.
     Der Geheimtipp-Satz bleibt als Erklaerung unter der Rolle. */
  function abzeichen(kaffee, geheim) {
    var html = '';
    if (geheim) {
      html += '<span class="lbkf__tipp">Passt zu dir — kennt aber kaum jemand.</span>';
    }
    if (kaffee.neu) {
      html += '<span class="lbkf__tipp lbkf__tipp--neu">Neu bei uns</span>';
    }
    return html;
  }

  /* Preiszeile aus dem bereits geholten Bestand. Kein zusaetzlicher Abruf:
     pruefeBestand hat jedem der zwoelf Treffer sein .stand angehaengt, bevor
     hier gezeichnet wird. */
  function preiszeile(stand, waehrung, handle) {
    if (!stand) return '<p class="lbkf__preis">Preis auf der Produktseite.</p>';
    if (!stand.verfuegbar) {
      return '<p class="lbkf__preis lbkf__leer">Zurzeit nicht lieferbar — ' +
        'meist nur für kurze Zeit.</p>';
    }
    /* Ohne Grundpreis oder ohne Einheit kein Preis: Bei abgepackter Ware nach
       Gewicht ist der Grundpreis Pflicht, und einen Gesamtpreis ohne ihn zu
       zeigen waere schlechter als gar keiner. Die Produktseite hat beides. */
    if (!stand.grundpreis || !stand.grundpreisEinheit) {
      return '<p class="lbkf__preis"><a href="/products/' + text(handle) +
        '">Preis auf der Produktseite</a></p>';
    }
    return '<p class="lbkf__preis"><strong>' + text(geld(stand.preis, waehrung)) +
      '</strong><span class="lbkf__grundpreis">' + text(stand.variantenName) +
      ' · ' + text(geld(stand.grundpreis, waehrung)) + ' / ' +
      text(stand.grundpreisEinheit) + '</span>' +
      (stand.roestdatum
        ? '<span class="lbkf__roestdatum">Geröstet am ' + text(stand.roestdatum) + '</span>'
        : '') + '</p>';
  }

  /* Die Rezept-Metaobjekte fuehren ihre Methode als "Siebtraeger", "Filter"
     oder "Vollautomat" -- das Produktfeld bohnen_zubereitungsart dagegen als
     "Siebtraeger", "Filterkaffee" oder "Vollautomat". Zwei Vokabulare fuer
     dieselbe Sache. Ohne diese Uebersetzung findet ein Handfilter-Nutzer nie
     ein Filterrezept, und der Rueckfall unten serviert ihm ein
     Espressorezept: 18 g mit 9 bar fuer jemanden, der von Hand aufgiesst. */
  var METHODE_ZU_REZEPT = {
    'Siebträger': 'Siebträger',
    'Vollautomat': 'Vollautomat',
    'Filterkaffee': 'Filter'
  };

  /* Das Rezept, das Frage 1 und 3 ausgewaehlt haben. Die Seite endet damit
     nicht beim Kauf, sondern beim Gelingen. */
  function passendesRezept(kaffee, zustand, rezepte) {
    var methoden = [];
    zustand.geraete.forEach(function (id) {
      L.GERAETE.forEach(function (g) {
        if (g.id !== id) return;
        var methode = METHODE_ZU_REZEPT[g.feld] || g.feld;
        if (methoden.indexOf(methode) === -1) methoden.push(methode);
      });
    });
    var eigene = (kaffee.rezepte || []).map(function (h) { return rezepte[h]; })
      .filter(Boolean);
    var passend = eigene.filter(function (r) { return methoden.indexOf(r.methode) !== -1; });
    /* Lieber gar kein Rezept als ein falsches: ein Espressorezept unter einem
       Handfilter-Ergebnis ist schlechter als eine leere Stelle. */
    return passend[0] || null;
  }

  var REZEPTZEILEN = [
    ['dosis', 'Dosis'], ['ausgabe', 'Ausgabe'], ['ratio', 'Verhältnis'],
    ['mahlgrad', 'Mahlgrad'], ['temperatur', 'Temperatur'], ['zeit', 'Zeit']
  ];

  function rezeptBlock(rezept, kaffeeName) {
    if (!rezept) return '';
    var zeilen = REZEPTZEILEN.filter(function (paar) { return rezept[paar[0]]; })
      .map(function (paar) {
        return '<div><dt>' + text(paar[1]) + '</dt><dd>' +
          text(rezept[paar[0]]) + '</dd></div>';
      }).join('');
    return '<section class="lbkf__rezept">' +
      '<h3>So machst du ' + (kaffeeName
        ? 'den ' + text(kaffeeName) : 'ihn') + '</h3>' +
      '<p class="lbkf__rezept-name">' + text(rezept.name) + '</p>' +
      '<dl class="lbkf__rezept-werte">' + zeilen + '</dl>' +
      (rezept.hinweis ? '<p class="lbkf__rezept-hinweis">' + text(rezept.hinweis) + '</p>' : '') +
      '</section>';
  }

  /* Eine Empfehlung bleibt eine Vermutung, bis jemand gekostet hat. Drei
     Tueten verwandeln eine unsichere Einzelentscheidung in einen sicheren
     Vergleich. Die 5 Prozent kommen vom automatischen Mengenrabatt "ab 3
     Kaffees" -- kein Code, der in Gutscheinportalen landet. */
  /* Statt eines Knopfes, der im Verborgenen drei Kaffees waehlt: Der Besucher
     haekchent selbst an, sieht sofort die Summe und was der Mengenrabatt
     abzieht, und legt dann in den Warenkorb. "Alle drei probieren" sagte
     weder welche drei noch was es kostet.
     Die besten drei lieferbaren sind vorgehakt -- der Vorschlag bleibt also
     erhalten, ist aber sichtbar und aenderbar. */
  function auswahlBlock(zehn, aboUrl, satz, versandUrl) {
    var waehlbar = zehn.filter(function (e) {
      return e.stand && e.stand.verfuegbar;
    });
    if (waehlbar.length < 2) return '';

    return '<section class="lbkf__auswahl" data-lbkf-auswahl>' +
      '<h3>Deine Kaffeekiste</h3>' +
      '<p class="lbkf__auswahl-hinweis">' + text(satz) + ' ' +
      'Ab drei Packungen ziehen wir 3 % ab, mit jeder weiteren 1 % mehr — ' +
      'bis 10 %. Ohne Code.</p>' +
      '<div class="lbkf__summe" data-lbkf-summe aria-live="polite"></div>' +
      /* Knopfklassen des Themes, nicht "button". Hyper kennt .button nicht --
         die 37 Treffer im Theme-CSS sind alle .button-list/.button-item.
         Mit class="button" stand hier monatelang nackter Text ohne Flaeche,
         genau da, wo gekauft wird. Richtig ist btn + btn--primary (im Schema
         der Seite bordeaux gefuellt) bzw. btn--secondary btn--small fuer die
         nachgeordneten Aktionen. Wer hier etwas aendert: erst im Theme-CSS
         nachsehen, ob die Klasse ueberhaupt existiert. */
      '<button type="button" class="btn btn--primary" data-lbkf-kaufen>In den Warenkorb</button>' +
      (aboUrl ? '<p class="lbkf__auswahl-hinweis">Wenn einer davon bleibt: ' +
        '<a href="' + text(aboUrl) + '">im Abo kommt er von allein</a>.</p>' : '') +
      '<p class="lbkf__auswahl-meldung" data-lbkf-meldung role="status" aria-live="polite"></p>' +
      preishinweis(versandUrl) +
      '</section>';
  }

  /* Vorgehakt sind die Karten oben (spitzenTrio). Der Satz sagt, ob das noch
     stimmt -- nach einer Verfeinerung bleibt die eigene Auswahl stehen. */
  function vorauswahlSatz(gewaehlt, trioHandles) {
    var gleich = gewaehlt.length === trioHandles.length &&
      trioHandles.every(function (h) { return gewaehlt.indexOf(h) !== -1; });
    if (gleich && gewaehlt.length > 1) {
      return 'Angehakt sind deine ' + (gewaehlt.length === 3 ? 'drei' : 'zwei') +
        ' Empfehlungen von oben — weitere kannst du unten dazunehmen.';
    }
    return 'Hak an, was du probieren willst.';
  }

  /* Pflichtangaben nach PAngV. Ueberall, wo einem Verbraucher ein Preis
     gezeigt wird, gehoeren vier Dinge zusammen: Gesamtpreis, Grundpreis,
     der Hinweis auf die enthaltene Umsatzsteuer und eine Angabe zu den
     Versandkosten. Der Finder zeigte nur die ersten beiden -- die
     Produktseite des Shops macht es vollstaendig, hier fehlte es.
     Ein Hinweis je Preisblock genuegt, er muss nicht an jeder der zehn
     Karten kleben. */
  function preishinweis(versandUrl) {
    return '<p class="lbkf__preishinweis">Alle Preise inkl. MwSt., ' +
      (versandUrl
        ? 'zzgl. <a href="' + text(versandUrl) + '">Versandkosten</a>.'
        : 'zzgl. Versandkosten.') + '</p>';
  }

  /* Staffel: ab 3 Packungen 3 %, je weitere Packung 1 % mehr, bei 10 %
     Schluss. Gezaehlt werden PACKUNGEN, nicht Sorten -- Shopifys
     Mindestmengenrabatt kann Sorten nicht unterscheiden, und fuenf Tueten
     desselben Lieblings sind auch eine Bestellung.

     ACHTUNG: Diese Zahlen muessen mit den automatischen Rabatten im Shop
     uebereinstimmen. Steht hier eine Staffel, die es im Warenkorb nicht
     gibt, verspricht der Finder mehr als der Shop einloest. Vor dem Go-live
     pruefen. */
  var RABATT_AB = 3;
  var RABATT_MAX = 10;

  function rabattProzent(anzahl) {
    if (anzahl < RABATT_AB) return 0;
    return Math.min(anzahl, RABATT_MAX);
  }

  /* Rechnet aus den gesetzten Haekchen die Summe und schreibt sie in den
     Kasten. Kein Neuzeichnen der Ergebnisliste -- das wuerde die
     Bestandspruefung erneut ausloesen und die Auswahl verlieren. */
  function aktualisiereSumme(wurzel) {
    var kasten = wurzel.querySelector('[data-lbkf-summe]');
    if (!kasten) return;
    var waehrung = wurzel.dataset.shopwaehrung;
    var preise = wurzel.lbkfPreise || {};
    var gewaehlt = [];
    wurzel.querySelectorAll('[data-lbkf-waehlen]').forEach(function (feld) {
      if (feld.checked && preise[feld.dataset.lbkfWaehlen]) {
        gewaehlt.push(preise[feld.dataset.lbkfWaehlen]);
      }
    });

    /* Zwei Knoepfe fuer denselben Kauf: in der Kiste und in der Leiste. */
    var knoepfe = wurzel.querySelectorAll('[data-lbkf-kaufen]');
    var leistenText = wurzel.querySelector('[data-lbkf-leiste-text]');
    zeigeLeiste(wurzel);
    if (!gewaehlt.length) {
      kasten.textContent = 'Noch nichts ausgewählt.';
      knoepfe.forEach(function (k) { k.disabled = true; });
      return;
    }
    /* Waehrend eine Warenkorbanfrage laeuft, bleibt der Knopf gesperrt. Vorher
       hob jedes Haekchen die Sperre auf -- wer waehrend "Wird in den Warenkorb
       gelegt ..." noch einen Kaffee anhakte und erneut tippte, legte alles
       doppelt ein. */
    if (!wurzel.lbkfKauftGerade) knoepfe.forEach(function (k) { k.disabled = false; });

    var summe = 0;
    gewaehlt.forEach(function (e) { summe += e.preis; });
    var prozent = rabattProzent(gewaehlt.length);
    var rabatt = Math.round(summe * prozent / 100);
    if (leistenText) {
      leistenText.innerHTML = '<strong>' + text(gewaehlt.length) +
        (gewaehlt.length === 1 ? ' Kaffee' : ' Kaffees') + '</strong> ' +
        text(geld(summe - rabatt, waehrung)) +
        (prozent ? ' <span>(−' + text(prozent) + ' %)</span>' : '');
    }

    var zeile = '<strong>' + text(gewaehlt.length) +
      (gewaehlt.length === 1 ? ' Kaffee' : ' Kaffees') + '</strong>' +
      '<span class="lbkf__summe-wert">' + text(geld(summe, waehrung)) + '</span>';
    if (rabatt) {
      zeile += '<span class="lbkf__summe-rabatt">− ' + text(geld(rabatt, waehrung)) +
        ' (' + text(prozent) + ' % Mengenrabatt)</span>' +
        '<span class="lbkf__summe-endpreis">' + text(geld(summe - rabatt, waehrung)) +
        '</span>';
      /* Die naechste Stufe nennen, solange es eine gibt -- eine erreichte
         Ersparnis ohne Ausblick laesst den Vorteil ungenutzt. */
      if (prozent < RABATT_MAX) {
        zeile += '<span class="lbkf__summe-naechste">Eine Packung mehr: ' +
          text(prozent + 1) + ' %</span>';
      }
    } else {
      /* Sagen, was fehlt -- eine Zahl ohne Weg dorthin hilft niemandem. */
      zeile += '<span class="lbkf__summe-rabatt">Noch ' +
        text(RABATT_AB - gewaehlt.length) +
        (RABATT_AB - gewaehlt.length === 1 ? ' Packung' : ' Packungen') +
        ' bis ' + text(RABATT_AB) + ' % Rabatt</span>';
    }

    /* Versand: Wer knapp unter der Schwelle liegt, soll das erfahren, bevor
       er im Warenkorb ueberrascht wird. Ueber die Schwelle hinweg ist es eine
       gute Nachricht, darunter eine ehrliche Auskunft. */
    var schwelle = parseFloat(wurzel.dataset.versandFreiAb || '0') * 100;
    var endpreis = summe - rabatt;
    if (schwelle > 0) {
      zeile += endpreis >= schwelle
        ? '<span class="lbkf__summe-versand lbkf__summe-versand--frei">' +
          'Versand innerhalb Deutschlands kostenfrei</span>'
        : '<span class="lbkf__summe-versand">Noch ' +
          text(geld(schwelle - endpreis, waehrung)) +
          ' bis zum kostenfreien Versand innerhalb Deutschlands</span>';
    }
    kasten.innerHTML = zeile;
  }

  /* Herkunft merken.

     Ohne das ist eine Bestellung aus dem Finder in Shopify von jeder anderen
     nicht zu unterscheiden -- die Wirkungsauswertung vom 06.09.2026 konnte
     deshalb nur mit Indizien arbeiten. Das Attribut haengt am Warenkorb, nicht
     an der Zeile: Shopify traegt Warenkorbattribute in die Bestellung, wo sie
     ueber order.customAttributes auszaehlbar sind.

     Sichtbar wird es nicht. Das Theme rendert aus cart.attributes
     ausschliesslich gift-wrapping und gift-note (snippets/gift-wrapping.liquid),
     Checkout und Bestellbestaetigung geben Warenkorbattribute von sich aus
     nicht aus. Bewusst NICHT die private Form mit doppeltem Unterstrich:
     die ist zwar unsichtbar, aber Shopify sagt nirgends zu, dass sie auf der
     Bestellung ankommt -- und genau darauf kommt es hier an.

     Das Datum steht im Wert, weil ein Warenkorb wochenlang liegen bleiben
     kann. Wer heute den Finder benutzt und in drei Wochen eine Muehle kauft,
     traegt das Attribut noch mit sich; am Datum ist das erkennbar.

     Wichtigste Regel: Der Aufruf darf den Kauf niemals aufhalten. Er bekommt
     eine eigene Zeitgrenze, wird in jedem Fall verschluckt und laeuft beim
     Paketkauf erst nach dem erfolgreichen Hinzufuegen -- ein misslungenes
     Merken ist eine fehlende Zahl, ein aufgehaltener Kauf ist ein
     verlorener Kunde. */
  var HERKUNFT_SCHLUESSEL = 'Kaffeefinder';
  var HERKUNFT_FRIST = 1500;

  /* Trichter melden: geoeffnet -> frage_beantwortet -> ergebnis.

     Das Warenkorbattribut sagt, ob der Finder verkauft. Es sagt nicht, wo
     die Leute aussteigen, die nicht kaufen -- und ob die internen Links
     (Megamenue, Startseiten-Banner, Fuss) ueberhaupt geklickt werden.
     Shopify-Analytics kann das nicht beantworten, es kennt nur
     Einstiegsseiten und keine Seitenaufrufe.

     Ziel ist die GA4-Property G-JKCXLT601H ueber den vorhandenen Container
     GTM-TCKXX4C. Geprueft am Containerexport vom 06.09.2026: dessen vier
     Ausloeser pruefen alle auf "ist gleich" mit einem festen Namen
     (analyzify_productDetail, analyzify_purchase, zwei Klickausloeser).
     Es gibt keinen Catch-all -- ein eigener Ereignisname kann dort also
     nichts ungewollt ausloesen. Ohne passendes Tag verpufft der Eintrag
     folgenlos in einem Array.

     Jeder Schritt meldet sich hoechstens einmal je Seitenaufruf. Ohne die
     Sperre feuerte "frage_beantwortet" bei jedem einzelnen Klick auf eine
     Kachel, und der Trichter zaehlte Bedienvorgaenge statt Menschen. */
  var TRICHTER_EREIGNIS = 'rc_kaffeefinder';
  var trichterGemeldet = {};

  function meldeSchritt(schritt) {
    if (trichterGemeldet[schritt]) return;
    trichterGemeldet[schritt] = true;
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: TRICHTER_EREIGNIS, schritt: schritt });
    } catch (fehler) {
      /* Messen ist Beiwerk. Es darf den Finder unter keinen Umstaenden
         anhalten. */
    }
  }

  function heuteAlsText() {
    var d = new Date();
    return d.getFullYear() + '-' +
      ('0' + (d.getMonth() + 1)).slice(-2) + '-' +
      ('0' + d.getDate()).slice(-2);
  }

  function merkeHerkunft(wert, beimVerlassen) {
    var attribute = {};
    attribute[HERKUNFT_SCHLUESSEL] = wert + ' ' + heuteAlsText();

    var anfrage;
    try {
      anfrage = fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        /* keepalive haelt die Anfrage am Leben, wenn der Klick auf einen
           Kaffee die Seite unmittelbar danach verlaesst. */
        keepalive: !!beimVerlassen,
        body: JSON.stringify({ attributes: attribute })
      });
    } catch (fehler) {
      return Promise.resolve();
    }

    /* Eigene Ableitung, damit eine Absage nach Ablauf der Frist nicht als
       unbehandelte Zurueckweisung in der Konsole landet. */
    var still = anfrage.then(null, function () {});
    var frist = new Promise(function (weiter) { setTimeout(weiter, HERKUNFT_FRIST); });
    return Promise.race([still, frist]);
  }

  function legeAuswahlInDenWarenkorb(wurzel) {
    var meldung = wurzel.querySelector('[data-lbkf-meldung]');
    var knoepfe = wurzel.querySelectorAll('[data-lbkf-kaufen]');
    if (wurzel.lbkfKauftGerade) return;
    knoepfe.forEach(function (k) { k.disabled = true; });
    wurzel.lbkfKauftGerade = true;
    var preise = wurzel.lbkfPreise || {};
    var posten = [];
    wurzel.querySelectorAll('[data-lbkf-waehlen]').forEach(function (feld) {
      var e = preise[feld.dataset.lbkfWaehlen];
      if (feld.checked && e) posten.push({ id: e.variantenId, quantity: 1 });
    });
    if (!posten.length) {
      wurzel.lbkfKauftGerade = false;
      knoepfe.forEach(function (k) { k.disabled = false; });
      return;
    }

    meldung.textContent = 'Wird in den Warenkorb gelegt …';
    ansage(wurzel, 'Wird in den Warenkorb gelegt …');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: posten })
    }).then(function (antwort) {
      if (!antwort.ok) throw new Error('HTTP ' + antwort.status);
      /* Erst kaufen, dann merken. /cart/add.js nimmt keine Attribute
         entgegen, das kann nur /cart/update.js -- es braucht also einen
         zweiten Aufruf. Der steht bewusst dahinter: der Artikel liegt dann
         schon im Warenkorb und kann durch nichts mehr verloren gehen, der
         Kaufweg bleibt unveraendert, und zwei Warenkorbschreibvorgaenge
         laufen nie gleichzeitig. Der Umweg kostet den Kunden im Regelfall
         etwa eine Zehntelsekunde vor der Weiterleitung, hoechstens die
         Frist aus merkeHerkunft. */
      return merkeHerkunft('Paket');
    }).then(function () {
      window.location.href = '/cart';
    }).catch(function () {
      meldung.textContent = 'Das hat nicht geklappt. Leg sie einzeln in den Warenkorb.';
      ansage(wurzel, 'Das hat nicht geklappt. Leg sie einzeln in den Warenkorb.');
      wurzel.lbkfKauftGerade = false;
      knoepfe.forEach(function (k) { k.disabled = false; });
    });
  }

  function ansage(wurzel, satz) {
    var feld = wurzel.querySelector('[data-lbkf-ansage]');
    if (feld) feld.textContent = satz;
  }

  /* Einzelkauf direkt von der Karte -- ohne Umweg ueber die Produktseite und
     ohne die Seite zu verlassen. Danach oeffnet sich der Warenkorb-Drawer des
     Themes (cart:refresh, siehe assets/cart.js), der auch den Zaehler im Kopf
     nachzieht. Gibt es keinen Drawer, bestaetigt der Knopf selbst.
     Merkmal "Direkt", damit dieser Weg getrennt von "Paket" (Kiste) und
     "Empfehlung" (Klick zur Produktseite) auszaehlbar ist.
     Hintereinander statt gleichzeitig: wer zwei Karten schnell nacheinander
     antippt, loest sonst zwei add.js und zwei update.js parallel aus. */
  function legeEinzelnInDenWarenkorb(wurzel, knopf) {
    var handle = knopf.dataset.lbkfEinzeln;
    var eintrag = (wurzel.lbkfPreise || {})[handle];
    if (!eintrag || knopf.disabled) return;
    var vorher = knopf.textContent;
    knopf.disabled = true;
    knopf.textContent = 'Wird hinzugefügt …';

    var vorgaenger = wurzel.lbkfReihe || Promise.resolve();
    wurzel.lbkfReihe = vorgaenger.then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: eintrag.variantenId, quantity: 1 }] })
      }).then(function (antwort) {
        if (!antwort.ok) throw new Error('HTTP ' + antwort.status);
        return merkeHerkunft('Direkt');
      }).then(function () {
        knopf.textContent = 'Im Warenkorb ✓';
        ansage(wurzel, 'Liegt im Warenkorb.');
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true, detail: { open: true }
        }));
        setTimeout(function () {
          knopf.textContent = vorher;
          knopf.disabled = false;
        }, 2500);
      }).catch(function () {
        knopf.textContent = 'Hat nicht geklappt – nochmal';
        ansage(wurzel, 'Das hat nicht geklappt.');
        knopf.disabled = false;
      });
    });
  }

  /* Oben drei gleich grosse Karten mit Rolle (spitzenTrio), darunter
     eingeklappt der Rest. Vorher eine grosse Karte und neun kleine offen --
     auf dem Desktop rund 2000, auf dem Handy rund 6000 Pixel zwischen Ergebnis
     und Kaufknopf.
     Jede kaufbare Karte hat zwei Wege: "In den Warenkorb" (bleibt auf der
     Seite) und "Zum Kaffee" (Produktseite). Den zweiten nicht abwerten --
     er trug in den ersten vier Wochen 20 von 23 Finder-Kaeufen. */
  function treffer(eintrag, zustand, daten, waehrung, vorgewaehlt, rolle) {
    var k = eintrag.kaffee;
    var oben = !!rolle;
    var gruende = begruendung(eintrag, zustand);
    var klassen = 'lbkf__treffer' + (oben ? ' lbkf__treffer--oben' : '') +
      (rolle === 'beste' ? ' lbkf__treffer--beste' : '');

    var bild = k.bild
      ? '<img class="lbkf__bild" src="' + text(k.bild) + '" alt="' +
        text(k.titel) + '" loading="lazy" width="160" height="160">'
      : '<span class="lbkf__bild lbkf__bild--fehlt" aria-hidden="true"></span>';

    /* Nur die Aromazeile -- in einer Kachel ist mehr nicht lesbar, und die
       Achse, nach der gefragt wurde, ist die wichtigste. Die beste Passung
       bekommt zusaetzlich Roestung und Staerke, weil sie die Frage "warum
       gerade der?" am ehesten aufwirft. */
    var grundtext = rolle === 'beste'
      ? '<dl class="lbkf__gruende">' + gruende.map(function (zeile) {
          return '<dt>' + text(zeile.achse) + '</dt><dd>' + text(zeile.text) + '</dd>';
        }).join('') + '</dl>'
      : '<p class="lbkf__grund">' + text(gruende[0].text) + '</p>';

    /* Haekchen und Kaufknopf nur, wo es etwas zu kaufen gibt. */
    var kaufbar = istKaufbar(eintrag);
    var waehlen = kaufbar
      ? '<label class="lbkf__waehlen"><input type="checkbox" data-lbkf-waehlen="' +
        text(k.handle) + '"' +
        ((vorgewaehlt || []).indexOf(k.handle) !== -1 ? ' checked' : '') +
        '><span>In meine Kaffeekiste</span></label>'
      : '';

    /* Der Satz nur am Geheimtipp. An der besten Passung stand er oft zugleich
       (sie ist haeufig selbst wenig verkauft) -- zweimal derselbe Satz in einer
       Reihe von drei Karten nimmt dem Tipp seine Besonderheit. */
    var geheim = rolle === 'geheim';
    var marke = oben
      ? '<span class="lbkf__beste-marke' + (rolle === 'auch' ? ' lbkf__beste-marke--leise' : '') +
        '">' + text(ROLLEN[rolle]) + '</span>'
      : '';

    var knoepfe = '<div class="lbkf__knoepfe">' +
      (kaufbar
        ? '<button type="button" class="btn btn--primary btn--small" data-lbkf-einzeln="' +
          text(k.handle) + '">In den Warenkorb</button>'
        : '') +
      '<a class="btn btn--secondary btn--small lbkf__zum-kaffee" href="/products/' +
        text(k.handle) + '">Zum Kaffee</a></div>';

    return '<li class="' + klassen + '">' +
      '<div class="lbkf__bildfeld">' + bild + '</div>' +
      '<div class="lbkf__treffer-text">' +
      marke +
      abzeichen(k, geheim) +
      '<h3 class="lbkf__name"><a href="/products/' + text(k.handle) + '">' +
        text(k.titel) + '</a></h3>' +
      '<p class="lbkf__roesterei">' + text(k.roesterei) + '</p>' +
      '<p class="lbkf__passungzeile">' +
      rosette(k.gruppen, daten.gruppenreihenfolge, daten.gruppenfarben, 44) +
      '<span class="lbkf__passung">' + (rolle === 'beste' ? 'passt zu ' : '') +
        text(eintrag.wertung.passung) + ' %</span></p>' +
      grundtext +
      preiszeile(eintrag.stand, waehrung, k.handle) +
      waehlen +
      knoepfe +
      '</div></li>';
  }

  function los() {
    if (!L) {
      if (window.console) console.error('Kaffeefinder: Logikdatei fehlt.');
      return;
    }
    var knoten = document.querySelectorAll('[data-lbkf]');
    for (var i = 0; i < knoten.length; i++) starte(knoten[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', los);
  } else {
    los();
  }
}());
